/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../../i18n/router';
import IconDinero from '../../../Icons/IconDinero';
import IconCerdito from '../../../Icons/IconCerdito';
import IconTarjetaTicket from '../../../Icons/IconTarjetaTicket';
import IconChef from '../../../Icons/IconChef';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import clubTarjeta from '../../../assets/images/club-tarjeta.png';
import TarjetaService from '../../../services/TarjetaService';
import SolicitarInformacionTPEC from '../commons/SolicitarInformacionTPEC';
import { StorageHelper } from '../../../utils/StorageHelper';
import TarjetaTemporalModificarCotitular from '../commons/TarjetaTemporalModificarCotitular';
import imagenHazteClub from '../../../assets/images/img-TarjetaHazteSocio.png';
import { CookieHelper } from '../../../utils/CookieHelper';
import { BackMappings } from '../../../utils/BackMappings';
import useSessionChecking from '../../../hooks/useSessionChecking';
import { CryptoUtil } from '../../../utils/CryptoUtil';

const CotitularEroski: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);

  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();

  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(true);
  const [cardNumberLong, setCardNumberLong] = useState<string>();
  const [cardNumberShort, setCardNumberShort] = useState<string>();
  const [controlDigit, setControlDigit] = useState<string>();
  const [firstCharge, setFirstCharge] = useState(true);

  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setLoad(false);
          addErrorBack(response.data);
        } else {
          setCardNumberLong(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberLong),
          );
          setCardNumberShort(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberShort),
          );
          setControlDigit(
            CryptoUtil.decryptAes(response.data.pojo.controlDigit),
          );
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  const moreInfo = (e) => {
    e.stopPropagation();
    e.preventDefault();
    StorageHelper.setForzeSinTarjetas();
    window.location.href = routerLoader.LoadRouterByPath(
      'tarjetas',
      dataApp.lang,
    );
  };
  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
      setLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
  });

  if (goOn) {
    return (
      <>
        <section className="header-tarjetas tarjetas">
          <div className="container">
            <div className="header-tarjetas__content">
              <h1 className="header-tarjetas__title">
                {t('tarjetas.tarjeta-club.title')}
              </h1>
              <p>
                {t('tarjetas.tarjeta-club.partner-number')}{' '}
                <strong>{cardNumberLong}</strong>
              </p>
            </div>
          </div>
        </section>

        <section className="o-section--giant__top u-padding-bottom-hero section--background">
          <div className="container-inner">
            <div className="img img-tarjeta">
              <img src={clubTarjeta} alt="Tarjeta Eroski Club" />
            </div>

            <div className="tarjeta__content">
              <h2 className="bloque-datos__title">
                <span className="divider__square brand-color" />
                <span className="u-margin-right">
                  {t('tarjetas.tarjeta-club.eroski-club')}
                </span>
              </h2>
              <TarjetaTemporalModificarCotitular />
            </div>
          </div>
        </section>

        <section className="o-section--superhero tarjetas">
          <div className="container">
            <h2 className="titulo-pagina u-text-brand u-text-center">
              {t('tarjetas.tarjeta-club.be-partner-block-title')}
            </h2>
            <div className="bloque-tarjeta bloque-tarjeta__club">
              <p className="etiqueta">
                {t('tarjetas.tarjeta-club.be-partner')}
              </p>
              <div className="bloque-tarjeta__contenido">
                <div className="img">
                  <img
                    src={imagenHazteClub}
                    alt="Imagen de una tarjeta pasandosela de una persona a otra"
                  />
                </div>

                <div className="bloque-tarjeta__content">
                  <p className="title__medium u-margin-bottom-small">
                    {t('tarjetas.tarjeta-club.cumulative-saving-block-title')}
                  </p>
                  <p className="u-margin-bottom-small font-weight-normal">
                    {t('tarjetas.tarjeta-club.advantages-and-more')}
                  </p>

                  <ul className="lista-ventajas">
                    <li className="lista-ventajas__item">
                      <div className="icon">
                        <IconDinero />
                      </div>

                      <span>{t('tarjetas.tarjeta-club.enjoy-offers')}</span>
                    </li>
                    <li className="lista-ventajas__item">
                      <div className="icon">
                        <IconCerdito />
                      </div>
                      <span>{t('tarjetas.tarjeta-club.see-data')}</span>
                    </li>
                    <li className="lista-ventajas__item">
                      <div className="icon">
                        <IconTarjetaTicket />
                      </div>
                      <span>{t('tarjetas.tarjeta-club.digital-ticket')}</span>
                    </li>
                    <li className="lista-ventajas__item">
                      <div className="icon">
                        <IconChef />
                      </div>
                      <span>{t('tarjetas.tarjeta-club.cook-class')}</span>
                    </li>
                  </ul>

                  <div className="botonera">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        StorageHelper.deleteUserFromSession();
                        CookieHelper.removeUserCookies();
                        document.location.href = `${process.env.REACT_APP_API}/${dataApp.lang}/nlrRegistrar/noTitular/tarjetas?fromApp=${dataUser.user.fromApp}&origenAP=tarjetas`;
                      }}
                    >
                      {t('tarjetas.tarjeta-club.to-request')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {(() => {
              if (!StorageHelper.isEcommerceBot()) {
                return <SolicitarInformacionTPEC />;
              }
              return false;
            })()}
          </div>
        </section>
      </>
    );
  }
  return <></>;
};

export default CotitularEroski;
